import type { ReactNode } from 'react'

interface UnassignedZoneProps {
  children: ReactNode
  count: number
}

export default function UnassignedZone({ children, count }: UnassignedZoneProps) {
  if (count === 0) return null

  return (
    <div className="mt-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex-1 border-t border-dashed border-muted-foreground/30" />
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider flex items-center gap-2">
          Unassigned Agents
          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-muted text-[10px] font-bold">
            {count}
          </span>
        </span>
        <div className="flex-1 border-t border-dashed border-muted-foreground/30" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {children}
      </div>
    </div>
  )
}
